import _asyncToGenerator from "/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.global-this.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var D = Object.defineProperty;
var $ = Object.getOwnPropertyDescriptor;
var F = Object.getOwnPropertyNames;
var U = Object.prototype.hasOwnProperty;
var ie = function ie(e, r) {
    for (var t in r) {
      D(e, t, {
        get: r[t],
        enumerable: !0
      });
    }
  },
  R = function R(e, r, t, n) {
    if (r && typeof r == "object" || typeof r == "function") {
      var _iterator = _createForOfIteratorHelper(F(r)),
        _step;
      try {
        var _loop = function _loop() {
          var a = _step.value;
          !U.call(e, a) && a !== t && D(e, a, {
            get: function get() {
              return r[a];
            },
            enumerable: !(n = $(r, a)) || n.enumerable
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  },
  le = function le(e, r, t) {
    return R(e, r, "default"), t && R(t, r, "default");
  };
var pe = function pe(e) {
  if (e.length == 0) return "";
  if (e.length == 1) return e[0];
  var r = e.slice(0, -1).join(", ");
  return r += ", or ".concat(e.slice(-1)), r;
};
function de() {
  return typeof window < "u";
}
var G = /^#?([A-F0-9]{6}|[A-F0-9]{3})$/i,
  N = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/i,
  j = /^rgba\((\d+),\s*(\d+),\s*(\d+)(,\s*\d+(\.\d+)?)\)$/i,
  B = /^hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)$/i,
  V = /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%(,\s*\d+(\.\d+)?)*\)$/i,
  g = function g(e) {
    return !!e.match(G);
  },
  b = function b(e) {
    return !!(e.match(N) || e.match(j));
  },
  h = function h(e) {
    return !!e.match(B) || !!e.match(V);
  },
  I = function I(e) {
    return typeof e != "string" && "r" in e;
  },
  E = function E(e) {
    return typeof e != "string" && "h" in e;
  },
  x = function x(e) {
    return e === "transparent";
  },
  fe = function fe(e) {
    return typeof e != "string" && e.a != null && e.a < 1;
  };
var X = /[hsla()]/g,
  Y = /[rgba()]/g,
  Ce = function Ce(e) {
    return e === "transparent" ? {
      h: 0,
      s: 0,
      l: 0,
      a: 0
    } : g(e) ? Q(e) : h(e) ? _(e) : b(e) ? w(e) : null;
  },
  be = function be(e) {
    return e = e.trim(), g(e) ? e.startsWith("#") ? e : "#".concat(e) : b(e) ? L(e) : h(e) ? _(e) : x(e) ? e : "";
  },
  z = function z(e) {
    return typeof e == "string" && (g(e) || x(e)) ? e : I(e) ? J(e) : E(e) ? Z(e) : "";
  },
  K = function K(e) {
    e = e.replace("#", "");
    var r = parseInt(e.substring(0, 2), 16),
      t = parseInt(e.substring(2, 4), 16),
      n = parseInt(e.substring(4, 6), 16);
    return {
      r: r,
      g: t,
      b: n
    };
  },
  J = function J(e) {
    var r = e.a,
      t = e.b,
      n = e.g,
      a = e.r;
    return e.a === 0 ? "transparent" : e.a != null ? "rgba(".concat(a, ",").concat(n, ",").concat(t, ",").concat(r, ")") : "rgb(".concat(a, ",").concat(n, ",").concat(t, ")");
  },
  Z = function Z(e) {
    var r = e.h,
      t = e.s,
      n = e.l,
      a = e.a,
      o = Math.round(t * 100),
      s = Math.round(n * 100);
    return e.a === 0 ? "transparent" : e.a != null ? "hsla(".concat(r, ",").concat(o, "%,").concat(s, "%,").concat(a, ")") : "hsl(".concat(r, ",").concat(o, "%,").concat(s, "%)");
  },
  Q = function Q(e) {
    var r = z(K(e));
    return w(r);
  },
  w = function w(e) {
    var r = L(e),
      t = r.r / 255,
      n = r.g / 255,
      a = r.b / 255,
      o = Math.max(t, n, a),
      s = Math.min(t, n, a),
      l,
      c,
      m = (o + s) / 2;
    if (o == s) l = c = 0;else {
      var i = o - s;
      switch (c = m >= .5 ? i / (2 - (o + s)) : i / (o + s), o) {
        case t:
          l = (n - a) / i * 60;
          break;
        case n:
          l = ((a - t) / i + 2) * 60;
          break;
        default:
          l = ((t - n) / i + 4) * 60;
          break;
      }
    }
    var u = {
        h: Math.round(l),
        s: c,
        l: m
      },
      f = r.a;
    return f != null && (u.a = f), u;
  },
  L = function L(e) {
    var _e$replace$split$map = e.replace(Y, "").split(",").map(function (o) {
        return Number.parseFloat(o);
      }),
      _e$replace$split$map2 = _slicedToArray(_e$replace$split$map, 4),
      r = _e$replace$split$map2[0],
      t = _e$replace$split$map2[1],
      n = _e$replace$split$map2[2],
      a = _e$replace$split$map2[3];
    return {
      r: r,
      g: t,
      b: n,
      a: a
    };
  },
  _ = function _(e) {
    var _e$replace$split$map3 = e.replace(X, "").split(",").map(function (o) {
        return Number.parseFloat(o);
      }),
      _e$replace$split$map4 = _slicedToArray(_e$replace$split$map3, 4),
      r = _e$replace$split$map4[0],
      t = _e$replace$split$map4[1],
      n = _e$replace$split$map4[2],
      a = _e$replace$split$map4[3];
    return {
      h: r,
      s: t / 100,
      l: n / 100,
      a: a
    };
  };
function T(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r];
    for (var n in t) {
      e[n] = t[n];
    }
  }
  return e;
}
var q = {
  read: function read(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function v(e, r) {
  function t(a, o, s) {
    if (!(typeof document > "u")) {
      s = T({}, r, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var l = "";
      for (var c in s) {
        !s[c] || (l += "; " + c, s[c] !== !0 && (l += "=" + s[c].split(";")[0]));
      }
      return document.cookie = a + "=" + e.write(o, a) + l;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], s = {}, l = 0; l < o.length; l++) {
        var c = o[l].split("="),
          m = c.slice(1).join("=");
        try {
          var u = decodeURIComponent(c[0]);
          if (s[u] = e.read(m, u), a === u) break;
        } catch (_unused) {}
      }
      return a ? s[a] : s;
    }
  }
  return Object.create({
    set: t,
    get: n,
    remove: function remove(a, o) {
      t(a, "", T({}, o, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(a) {
      return v(this.converter, T({}, this.attributes, a));
    },
    withConverter: function withConverter(a) {
      return v(T({}, this.converter, a), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(r)
    },
    converter: {
      value: Object.freeze(e)
    }
  });
}
var ee = v(q, {
    path: "/"
  }),
  C = ee;
function ye(e) {
  return {
    get: function get() {
      return C.get(e);
    },
    set: function set(r) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return C.set(e, r, t);
    },
    remove: function remove(r) {
      C.remove(e, r);
    }
  };
}
function Se(e) {
  return e ? e.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "numeric",
    hour12: !0
  }) : "";
}
function re(e, r) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$absolute = _ref.absolute,
    t = _ref$absolute === void 0 ? !0 : _ref$absolute;
  if (!e || !r) return 0;
  var n = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()),
    a = Date.UTC(r.getFullYear(), r.getMonth(), r.getDate()),
    o = Math.floor((a - n) / 864e5);
  return t ? Math.abs(o) : o;
}
function y(e) {
  try {
    return new Date(e || new Date());
  } catch (_unused2) {
    return new Date();
  }
}
function Re(e) {
  var r = e.date,
    t = e.relativeTo;
  if (!r || !t) return null;
  var n = y(r),
    a = y(t),
    o = re(a, n, {
      absolute: !1
    });
  return o < -6 ? {
    relativeDateCase: "other",
    date: n
  } : o < -1 ? {
    relativeDateCase: "previous6Days",
    date: n
  } : o === -1 ? {
    relativeDateCase: "lastDay",
    date: n
  } : o === 0 ? {
    relativeDateCase: "sameDay",
    date: n
  } : o === 1 ? {
    relativeDateCase: "nextDay",
    date: n
  } : o < 7 ? {
    relativeDateCase: "next6Days",
    date: n
  } : {
    relativeDateCase: "other",
    date: n
  };
}
function De(e, r) {
  var t = y(e);
  return t.setFullYear(t.getFullYear() + r), t;
}
function Ee(e) {
  return new Promise(function (r, t) {
    var n = new FileReader();
    n.addEventListener("load", function () {
      var a = JSON.parse(n.result);
      r(a);
    }), n.addEventListener("error", t), n.readAsText(e);
  });
}
function Le() {
  if (!window.matchMedia) return !1;
  var e = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
  return e && e.matches || window.devicePixelRatio > 1;
}
var te = "__lsbc__",
  P = /*#__PURE__*/function () {
    function P(r) {
      var _this = this;
      _classCallCheck(this, P);
      this.eventTarget = window;
      this.postMessage = function (r) {
        try {
          localStorage.setItem(_this.channelKey, JSON.stringify(r)), localStorage.removeItem(_this.channelKey);
        } catch (_unused3) {}
      };
      this.addEventListener = function (r, t) {
        _this.eventTarget.addEventListener(_this.prefixEventName(r), function (n) {
          t(n);
        });
      };
      this.setupLocalStorageListener = function () {
        var r = function r(t) {
          if (!(t.key !== _this.channelKey || !t.newValue)) try {
            var n = JSON.parse(t.newValue || ""),
              a = new MessageEvent(_this.prefixEventName("message"), {
                data: n
              });
            _this.eventTarget.dispatchEvent(a);
          } catch (_unused4) {}
        };
        window.addEventListener("storage", r);
      };
      this.channelKey = te + r, this.setupLocalStorageListener();
    }
    _createClass(P, [{
      key: "prefixEventName",
      value: function prefixEventName(r) {
        return this.channelKey + r;
      }
    }]);
    return P;
  }();
var ne = Object.freeze({
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/x-icon": "ico",
    "image/vnd.microsoft.icon": "ico"
  }),
  We = function We(e) {
    return ne[e];
  };
var W = function W() {};
var oe = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
function He(e) {
  return oe.test(e || "");
}
function Oe(e) {
  var r = e || "";
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function M(e) {
  return e ? e.replace(/([-_][a-z])/g, function (r) {
    return r.toUpperCase().replace(/-|_/, "");
  }) : "";
}
function A(e) {
  return e ? e.replace(/[A-Z]/g, function (r) {
    return "_".concat(r.toLowerCase());
  }) : "";
}
var H = function H(e) {
    var r = function r(t) {
      if (!t) return t;
      if (Array.isArray(t)) return t.map(function (o) {
        return typeof o == "object" || Array.isArray(o) ? r(o) : o;
      });
      var n = _objectSpread({}, t),
        a = Object.keys(n);
      for (var _i = 0, _a = a; _i < _a.length; _i++) {
        var o = _a[_i];
        var s = e(o.toString());
        s !== o && (n[s] = n[o], delete n[o]), typeof n[s] == "object" && (n[s] = r(n[s]));
      }
      return n;
    };
    return r;
  },
  Ue = H(A),
  Ge = H(M);
var k = "const respond=r=>{self.postMessage(r)},workerToTabIds={};self.addEventListener(\"message\",r=>{const e=r.data;switch(e.type){case\"setTimeout\":workerToTabIds[e.id]=setTimeout(()=>{respond({id:e.id})},e.ms);break;case\"clearTimeout\":workerToTabIds[e.id]&&(clearTimeout(workerToTabIds[e.id]),delete workerToTabIds[e.id]);break;case\"setInterval\":workerToTabIds[e.id]=setInterval(()=>{respond({id:e.id})},e.ms);break;case\"clearInterval\":workerToTabIds[e.id]&&(clearInterval(workerToTabIds[e.id]),delete workerToTabIds[e.id]);break}});\n";
var O = function O(e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (typeof Worker > "u") return null;
    try {
      var t = new Blob([e], {
          type: "application/javascript; charset=utf-8"
        }),
        n = globalThis.URL.createObjectURL(t);
      return new Worker(n, r);
    } catch (_unused5) {
      return console.warn("Clerk: Cannot create worker from blob. Consider adding worker-src blob:; to your CSP"), null;
    }
  },
  se = function se() {
    var e = globalThis.setTimeout.bind(globalThis),
      r = globalThis.setInterval.bind(globalThis),
      t = globalThis.clearTimeout.bind(globalThis),
      n = globalThis.clearInterval.bind(globalThis);
    return {
      setTimeout: e,
      setInterval: r,
      clearTimeout: t,
      clearInterval: n,
      cleanup: W
    };
  },
  S = function S() {
    var e = 0,
      r = function r() {
        return e++;
      },
      t = new Map(),
      n = function n(i, p) {
        return i == null ? void 0 : i.postMessage(p);
      },
      a = function a(i) {
        var p;
        (p = t.get(i.data.id)) == null || p();
      },
      o = O(k, {
        name: "clerk-timers"
      });
    if (o == null || o.addEventListener("message", a), !o) return se();
    var s = function s() {
      o || (o = O(k, {
        name: "clerk-timers"
      }), o == null || o.addEventListener("message", a));
    };
    return {
      setTimeout: function setTimeout(i, p) {
        s();
        var d = r();
        return t.set(d, i), n(o, {
          type: "setTimeout",
          id: d,
          ms: p
        }), d;
      },
      setInterval: function setInterval(i, p) {
        s();
        var d = r();
        return t.set(d, i), n(o, {
          type: "setInterval",
          id: d,
          ms: p
        }), d;
      },
      clearTimeout: function clearTimeout(i) {
        s(), t.delete(i), n(o, {
          type: "clearTimeout",
          id: i
        });
      },
      clearInterval: function clearInterval(i) {
        s(), t.delete(i), n(o, {
          type: "clearInterval",
          id: i
        });
      },
      cleanup: function cleanup() {
        o && (o.terminate(), o = null, t.clear());
      }
    };
  };
function Je() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      delayInMs: 1e3
    },
    e = _ref2.delayInMs;
  var r = S(),
    t,
    n = !1,
    a = function a() {
      t && (r.clearTimeout(t), r.cleanup()), n = !0;
    },
    o = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                n = !1;
                _context.next = 3;
                return s(a);
              case 3:
                !n && (t = r.setTimeout(function () {
                  o(s);
                }, e));
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function o(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
  return {
    run: o,
    stop: a
  };
}
var Qe = function Qe() {
  return typeof window < "u";
};
function er() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return e.startsWith("?") && (e = e.slice(1)), new URLSearchParams(e);
}
export { ie as a, le as b, pe as c, de as d, g as e, b as f, h as g, I as h, E as i, x as j, fe as k, Ce as l, be as m, z as n, K as o, ye as p, Se as q, re as r, y as s, Re as t, De as u, Ee as v, Le as w, P as x, We as y, W as z, He as A, Oe as B, M as C, A as D, Ue as E, Ge as F, S as G, Je as H, Qe as I, er as J };
/*! js-cookie v3.0.1 | MIT */